// extracted by mini-css-extract-plugin
export default {"topBox":"styles_topBox__IUT2H","icon":"styles_icon__jbPKW","title":"styles_title__CH0hZ","text":"styles_text__AVHIr","button":"styles_button__eB4ea"};